export default "__VITE_ASSET__spW_SFx9__"